import React, { useContext, useState, useEffect, useRef } from 'react';
import { Col, Row, Form, Button, Container, Card, InputGroup } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { schema } from '../../schema';
import { Formik, FieldArray, getIn, FormikProps, setNestedObjectValues } from 'formik';
import "../../optional"; // custom "optional" function for yup validation
import modelContext from '../../modelContext';
import { EventForm } from './event_types';
import { EventCompart3, EventCompart6 } from './EventComparts';
import { CustomSelect } from '../CustomFormHandling/CustomSelect';


export default function FormEvents(props: any) {
	let emptyEvent = {
		_attributes: {
			name: "",
			type: "",
			trigger: "",
			probability: "1"
		},
	}
	let empty_event_type_node = {
		_attributes: {
			id: "",
			amount: ""
		}
	}

	let time_trigger_node = {
		_attributes: {
			repeat: "false",
			initial: ""
		}
	}
	let event_trigger_node = {
		_attributes: {
			name: "",
			delay: ""
		}
	}
	let state_trigger_node = {
		_attributes: {
			condition: "",
			id: "",
			amount: "",
			repeat: "false",
			interval: ""
			//initial: ""
		}
	}

	let empty_loc_compart = {
		_attributes: {
			compartment: "",
		}
	}
	let empty_loc_point = {
		_attributes: {
			xloc: "",
			yloc: "",
			zloc: "",
		}
	}
	let empty_loc_shape = {
		_attributes: {
			xloc_1: "",
			yloc_1: "",
			zloc_1: "",
			xloc_2: "",
			yloc_2: "",
			zloc_2: "",
		}
	}

	const model = useContext(modelContext);

	const [submitSuccess, setSubmitSuccess] = useState(false);
	const [touchedSubmit, setTouchedSubmit] = useState(false);
	useEffect(() => { }, [submitSuccess])
	useEffect(() => { }, [touchedSubmit])


	// formik reference
	const formRef = useRef<FormikProps<EventForm>>(null);
	const [initialValues, setInitialValues] = useState(props.initialValues);

	// This function handles overwriting existing forms by uploading a new form. it clears the existing one first, then replaces the blank from with new data
	// the setTimeout is a workaround because you cannot listen for changes made to setFieldValue, which is async.
	// the overwrite is needed because the checkboxes that toggle membrane field options can be stale when updated from upload, so everything needs to be cleared.
	// fix in the future if possible, but no big deal
	const handleFieldOverwrite = () => {
		if (formRef?.current) {
			formRef?.current.setFieldValue(`event`, []);
			setTimeout(() => {
				formRef?.current?.setFieldValue(`event`, model.modelJson["listOfEvents"].event);
			}, 100)
		}
	}
	useEffect(() => {
		setInitialValues(props.initialValues);
		handleFieldOverwrite();
	}, [props.initialValues])

	// This function allows the correct location type dropdown option to be selected when external models are loaded. Without this, loaded models will always display
	// the first option even if other options are being used
	const getSelectedLocationType = (attributes: any) => {
		let length = 0;
		if (attributes) {
			length = Object.keys(attributes).length;
		}
		if (length === 1) {
			return ("compart")
		} else if (length === 3) {
			return ("point")
		} else if (length === 6) {
			return ("shape")
		} else {
			return ("")
		}
	}

	useEffect(() => {
		if (formRef?.current) {
			if (formRef.current.values["event"].length !== 0) {
				formRef.current.validateForm();
				setTimeout(() => {
					formRef?.current?.setTouched(setNestedObjectValues(formRef.current.errors, true));
				}, 100)
			}
		}
	}, [model.compartList, model.speciesList])

	const errorsMap = (error_string: string): string => {
		let return_string = "";
		if (error_string === "missing_var") {
			return_string = "This field cannot be empty.";
		} else if (error_string === "invalid_var") {
			return_string = "This field is invalid.";
		} else if (error_string === "no_match") {
			return_string = "The selected option is no longer valid. Please choose a new option.";
		}
		return (return_string);
	}

	const showMismatchError = (input_string: string): string => {
		let errorsList: Array<string> = [];
		let errorMsg = "";
		if (formRef?.current) {
			let errorObj = getIn(formRef?.current.errors, input_string);
			let touchedObj = {};
			if (touchedObj) {
				touchedObj = getIn(formRef?.current.touched, input_string);
			}
			if (errorObj && touchedObj) {
				errorMsg = "Coordinates cannot be empty.";
				errorsList = Object.values(errorObj);
				errorsList.forEach((error: string) => {
					if (error === "invalid_var") {
						errorMsg = "Coordinates must be 0 or a positive integer.";
					}
				})
			}

		}
		return (errorMsg);
	}

	const handleSubmit = (values: any) => {
		let events_out = {
			"event": values["event"]
		}

		// because handleSubmit was successfully called, new events tab is correct for sure, so set it to true.
		let temp_modelStatus: Array<Boolean> = model.validateModel();
		temp_modelStatus[5] = true;
		model.setModelStatus(temp_modelStatus);

		model.appendModelJson("listOfEvents", events_out);
		console.log(JSON.stringify(values["event"]));

		setSubmitSuccess(true);
		setTouchedSubmit(false);

	}

	return (
		<div>
			<Formik
				innerRef={formRef}
				validationSchema={schema.events(model.compartList, model.speciesList)}
				onSubmit={handleSubmit}
				enableReinitialize={false}
				initialValues={initialValues} >
				{({
					handleSubmit,
					handleChange,
					handleBlur,
					setFieldValue,
					values,
					touched,
					errors,
				}) => (
					<Form onSubmit={handleSubmit} noValidate autoComplete="off">
						<Container>
							<FieldArray name="event" render={arrayHelpers => {
								return (<div> {
									values?.["event"] && values?.["event"].length > 0 ? values["event"].map((event: any, index: number) => (
										<div key={index}>
											{/* Big card holding each event's group of fields */}
											<Card >
												{/* First row has event name, event type card, and event trigger card */}
												<Row style={{ paddingTop: 10 }}>
													<Col xs={3} style={{ paddingLeft: 30 }}>
														<Form.Label>Event name</Form.Label>
														<Form.Control className="form-control" size="sm"
															name={`event.[${index}]._attributes.name`}
															value={values["event"][index]._attributes.name}
															onChange={handleChange}
															onBlur={handleBlur}
															isValid={getIn(touched, `event.[${index}]._attributes.name`) &&
																!getIn(errors, `event.[${index}]._attributes.name`)}
															isInvalid={getIn(touched, `event.[${index}]._attributes.name`) &&
																!!getIn(errors, `event.[${index}]._attributes.name`)} />
														<Form.Control.Feedback type="invalid">{errorsMap(getIn(errors, `event.[${index}]._attributes.name`))}</Form.Control.Feedback>
														<br />
														<Form.Label>Event probability</Form.Label>
														<Form.Control className="form-control" size="sm"
															type="number"
															name={`event.[${index}]._attributes.probability`}
															value={values["event"][index]._attributes.probability}
															onChange={handleChange}
															onBlur={handleBlur}
															isValid={getIn(touched, `event.[${index}]._attributes.probability`) &&
																!getIn(errors, `event.[${index}]._attributes.probability`)}
															isInvalid={getIn(touched, `event.[${index}]._attributes.probability`) &&
																!!getIn(errors, `event.[${index}]._attributes.probability`)} />
														<Form.Control.Feedback type="invalid">{errorsMap(getIn(errors, `event.[${index}]._attributes.probability`))}</Form.Control.Feedback>
														<br />
														{/* Provides a dropdown for 3 different formats of location definitions: compart name dropdown, xyz points, xyz range of points */}
														<Form.Label>Event Location definition</Form.Label>
														<Row className="justify-content-md-center">
															<Col>
																<Form.Control as="select" custom
																	id="dropdown-basic-button"
																	size="sm"
																	onBlur={handleBlur}
																	defaultValue={getSelectedLocationType(values["event"]?.[index]?.location?._attributes)}
																	onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																		// add the relevant event type node when it is selected from drop down, remove all others
																		handleChange(e);
																		let current_location_value = JSON.parse(JSON.stringify(values["event"][index]));;
																		// deep copy the current values rather than reassign object reference then modifying
																		if (e.target.value === "compart") {
																			current_location_value["location"] = empty_loc_compart;
																		} else if (e.target.value === "point") {
																			current_location_value["location"] = empty_loc_point;
																		} else if (e.target.value === "shape") {
																			current_location_value["location"] = empty_loc_shape;
																		}
																		if (e.target.value) {
																			setFieldValue(`event.[${index}]`, current_location_value)
																		}
																	}}
																>
																	{!values["event"]?.[index]?.location ?
																		<option value="">choose option</option>
																		: null}
																	<option value="compart">Compartment</option>
																	<option value="point">C-voxel point</option>
																	<option value="shape">C-voxel range</option>
																</Form.Control>
															</Col>
														</Row>
														{/* Depending on which item was selected above, render the appropriate forms */}
														{/* This one is compartment list dropdown */}
														{values["event"]?.[index]?.location && Object.keys(values["event"]?.[index]?.location?._attributes).length === 1 ?
															<>
																<Row>
																	<Col>
																		<InputGroup size="sm">
																			<InputGroup.Prepend>
																				<InputGroup.Text>Name</InputGroup.Text>
																			</InputGroup.Prepend>
																			<CustomSelect
																				name={`event.[${index}].location._attributes.compartment`}
																				value={values["event"][index].location._attributes.compartment}
																				defaultOptionString="compartment"
																				touched={touched}
																				errors={errors}
																				optionsArray={model.compartList}
																				onChange={handleChange}
																				onBlur={handleBlur} />
																		</InputGroup>
																		<Row className="justify-content-center custom-error">
																			{errorsMap(getIn(errors, `event.[${index}].location._attributes.compartment`))}
																		</Row>
																	</Col>
																</Row>
															</>
															: null}
														{/* This one is xyz coord for 1 point. Its only identifier is the number of its attributes, not a label*/}
														{values["event"]?.[index]?.location && Object.keys(values["event"]?.[index]?.location?._attributes).length === 3 ?
															<EventCompart3
																name={`event.[${index}].location._attributes`}
																value={values["event"][index].location._attributes}
																touched={touched}
																errors={errors}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
															: null}
														{/* This one is a range of points from 6 coordinates in xyz */}
														{values["event"]?.[index]?.location && Object.keys(values["event"]?.[index]?.location?._attributes).length === 6 ?
															<EventCompart6
																name={`event.[${index}].location._attributes`}
																value={values["event"][index].location._attributes}
																touched={touched}
																errors={errors}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
															: null}
													</Col>

													<Col xs={4}>
														{/* a light-bordered card for the event type info */}
														<Card><Card.Body>
															<Row className="justify-content-md-center" style={{ marginTop: -10 }}>
																<Col xs={10}>
																	<Form.Label>Event type</Form.Label>
																	<Form.Control as="select" custom
																		id="dropdown-basic-button"
																		size="sm"
																		name={`event.[${index}]._attributes.type`}
																		value={values["event"][index]._attributes.type}
																		onBlur={handleBlur}
																		onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																			// add the relevant event type node when it is selected from drop down, remove all others
																			handleChange(e);
																			// deep copy the current values rather than reassign object reference then modifying
																			let current_event_value = JSON.parse(JSON.stringify(values["event"][index]));;
																			if (e.target.value === "add_mols") {
																				current_event_value["add_mols"] = empty_event_type_node;
																				delete current_event_value["remove_mols"];
																				delete current_event_value["transport_mols"];
																				delete current_event_value["transport_destination"];
																			} else if (e.target.value === "remove_mols") {
																				current_event_value["remove_mols"] = empty_event_type_node;
																				delete current_event_value["add_mols"];
																				delete current_event_value["transport_mols"];
																				delete current_event_value["transport_destination"];
																			} else if (e.target.value === "transport_mols") {
																				current_event_value["transport_mols"] = empty_event_type_node;
																				delete current_event_value["add_mols"];
																				delete current_event_value["remove_mols"];
																			}
																			current_event_value._attributes.type = e.target.value;
																			setFieldValue(`event.[${index}]`, current_event_value)
																		}}
																	>
																		{!values["event"][index]._attributes.type ?
																			<option value="">choose option</option>
																			: null}
																		<option value="add_mols">Add molecules</option>
																		<option value="remove_mols">Remove molecules</option>
																		<option value="transport_mols">Molecule transport</option>
																	</Form.Control>
																</Col>
															</Row>
															<Row className="justify-content-md-center">
																{/* Event type fields, includes target molecule name + amount */}
																{/* Will correctly fill the correct node (add_mols, delete_mols, or transport_mols) */}
																{values?.["event"]?.[index]?._attributes?.type ?
																	<>
																		<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																			{values["event"][index]._attributes.type === "add_mols" ? <Form.Label>Molecules to add</Form.Label> : null}
																			{values["event"][index]._attributes.type === "remove_mols" ? <Form.Label>Molecules to remove</Form.Label> : null}
																			{values["event"][index]._attributes.type === "transport_mols" ? <Form.Label>Molecules to transport</Form.Label> : null}
																			<InputGroup>
																				<Form.Control as="select" custom
																					id="dropdown-basic-button"
																					size="sm"
																					name={`event.[${index}].${values["event"][index]._attributes.type}._attributes.id`}
																					value={values["event"][index][values["event"][index]._attributes.type]._attributes.id}
																					onBlur={handleBlur}
																					onChange={handleChange}
																				>
																					{!values["event"][index][values["event"][index]._attributes.type]._attributes.id ?
																						<option value="">molecule</option>
																						: null}
																					{model.speciesList.map((species_name: string) => {
																						return (
																							<option value={species_name}>{species_name}</option>
																						)
																					})}
																				</Form.Control>
																				<Form.Control className="form-control" size="sm"
																					type="number"
																					name={`event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`}
																					value={values["event"][index][values["event"][index]._attributes.type]._attributes.amount}
																					onChange={handleChange}
																					onBlur={handleBlur}
																					isValid={getIn(touched, `event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`) &&
																						!getIn(errors, `event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`)}
																					isInvalid={getIn(touched, `event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`) &&
																						!!getIn(errors, `event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`)} />
																				<Form.Control.Feedback type="invalid">{errorsMap(getIn(errors, `event.[${index}].${values["event"][index]._attributes.type}._attributes.amount`))}</Form.Control.Feedback>

																			</InputGroup>
																		</Col>
																	</>
																	: null}
															</Row>
															{values["event"][index]?._attributes?.type === "transport_mols" ?
																<div>
																	{/* Provides a dropdown for 3 different formats of location definitions: compart name dropdown, xyz points, xyz range of points */}
																	<Form.Label>Transport destination</Form.Label>
																	<Row className="justify-content-md-center">
																		<Col xs={10}>
																			<Form.Control as="select" custom
																				id="dropdown-basic-button"
																				size="sm"
																				onBlur={handleBlur}
																				// this chooses the correct dropdown option depending on what currently exists. useful for loading models
																				defaultValue={getSelectedLocationType(values["event"]?.[index]?.transport_destination?._attributes)}
																				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																					// add the relevant event type node when it is selected from drop down, remove all others
																					handleChange(e);
																					// deep copy the current values rather than reassign object reference then modifying
																					if (e.target.value === "compart") {
																						setFieldValue(`event.[${index}].transport_destination`, empty_loc_compart)
																					} else if (e.target.value === "point") {
																						setFieldValue(`event.[${index}].transport_destination`, empty_loc_point)
																					} else if (e.target.value === "shape") {
																						setFieldValue(`event.[${index}].transport_destination`, empty_loc_shape)
																					}
																				}}
																			>
																				{!values["event"]?.[index]?.location ?
																					<option value="">choose option</option>
																					: null}
																				<option value="compart">Compartment</option>
																				<option value="point">C-voxel point</option>
																				<option value="shape">C-voxel range</option>
																			</Form.Control>
																		</Col>
																	</Row>
																	{/* Depending on which item was selected above, render the appropriate forms */}
																	{/* This one is compartment list dropdown */}
																	{values["event"]?.[index]?.transport_destination && Object.keys(values["event"]?.[index]?.transport_destination?._attributes).length === 1 ?
																		<Row className="justify-content-md-center">
																			<Col xs={10}>
																				<InputGroup size="sm">
																					<InputGroup.Prepend>
																						<InputGroup.Text>Name</InputGroup.Text>
																					</InputGroup.Prepend>
																					<CustomSelect
																						name={`event.[${index}].transport_destination._attributes.compartment`}
																						value={values["event"][index].transport_destination._attributes.compartment}
																						defaultOptionString="compartment"
																						touched={touched}
																						errors={errors}
																						optionsArray={model.compartList}
																						onChange={handleChange}
																						onBlur={handleBlur} />
																				</InputGroup>
																				<Row className="justify-content-center custom-error">
																					{errorsMap(getIn(errors, `event.[${index}].transport_destination._attributes.compartment`))}
																				</Row>
																			</Col>
																		</Row>
																		: null}
																	{/* This one is xyz coord for 1 point. It's only identifier is the number of its attributes, not a label*/}
																	{values["event"]?.[index]?.transport_destination && Object.keys(values["event"]?.[index]?.transport_destination?._attributes).length === 3 ?
																		<EventCompart3
																			name={`event.[${index}].transport_destination._attributes`}
																			value={values["event"][index].transport_destination._attributes}
																			touched={touched}
																			errors={errors}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		: null}
																	{/* This one is a range of points from 6 coordinates in xyz */}
																	{values["event"]?.[index]?.transport_destination && Object.keys(values["event"]?.[index]?.transport_destination?._attributes).length === 6 ?
																		<EventCompart6
																			name={`event.[${index}].transport_destination._attributes`}
																			value={values["event"][index].transport_destination._attributes}
																			touched={touched}
																			errors={errors}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		: null}
																</div>
																: null}
														</Card.Body></Card>
													</Col>

													<Col xs={5} style={{ paddingRight: 30 }}>
														<Card><Card.Body>
															<Row className="justify-content-md-center" style={{ marginTop: -10 }}>
																<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																	<Form.Label>Event trigger</Form.Label>
																	<Form.Control as="select" custom
																		id="dropdown-basic-button"
																		size="sm"
																		name={`event.[${index}]._attributes.trigger`}
																		value={values["event"][index]._attributes.trigger}
																		onBlur={handleBlur}
																		onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																			// add the relevant event type node when it is selected from drop down, remove all others
																			handleChange(e);
																			// deep copy the current values rather than reassign object reference then modifying
																			let current_event_value = JSON.parse(JSON.stringify(values["event"][index]));;
																			if (e.target.value === "time") {
																				current_event_value["time_trigger"] = time_trigger_node;
																				delete current_event_value["event_trigger"];
																				delete current_event_value["state"];
																				delete current_event_value["state_trigger_loc"];
																			} else if (e.target.value === "event") {
																				current_event_value["event_trigger"] = event_trigger_node;
																				delete current_event_value["time"];
																				delete current_event_value["state"];
																				delete current_event_value["state_trigger_loc"];
																			} else if (e.target.value === "state") {
																				current_event_value["state_trigger"] = state_trigger_node;
																				delete current_event_value["time"];
																				delete current_event_value["event"];
																			}
																			current_event_value._attributes.trigger = e.target.value;
																			setFieldValue(`event.[${index}]`, current_event_value)
																		}}
																	>

																		{!values["event"][index]._attributes.trigger ?
																			<option value="">choose option</option>
																			: null}
																		<option value="time">Time triggered</option>
																		<option value="event">Event triggered</option>
																		<option value="state">State triggered</option>
																	</Form.Control>
																</Col>
																<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																	{values?.["event"]?.[index]?._attributes?.trigger === "time" && values?.["event"]?.[index]?.time_trigger ?
																		<>
																			<Form.Label>Repeat interval</Form.Label>
																			<InputGroup>
																				<InputGroup.Prepend>
																					<InputGroup.Checkbox
																						checked={values["event"][index].time_trigger._attributes.repeat === "true"}
																						onClick={(e: any) => {
																							let temp_time_trigger = JSON.parse(JSON.stringify(values["event"][index].time_trigger));
																							if (!e.target.checked) {
																								delete temp_time_trigger._attributes.interval;
																								temp_time_trigger._attributes.repeat = "false";
																							} else {
																								temp_time_trigger._attributes.interval = "";
																								temp_time_trigger._attributes.repeat = "true";
																							}
																							setFieldValue(`event.[${index}].time_trigger`, temp_time_trigger);
																						}} />
																				</InputGroup.Prepend>
																				{/* show trigger interval field or dummy depending on if event is repeatable */}
																				{values["event"][index].time_trigger._attributes.repeat ? <>
																					<Form.Control className="form-control" size="sm"
																						type="number"
																						name={`event.[${index}].time_trigger._attributes.interval`}
																						value={values["event"][index].time_trigger._attributes.interval}
																						disabled={values["event"][index].time_trigger._attributes.repeat !== "true"}
																						onChange={handleChange}
																						onBlur={handleBlur}
																						isValid={getIn(touched, `event.[${index}].time_trigger._attributes.interval`) &&
																							!getIn(errors, `event.[${index}].time_trigger._attributes.interval`)}
																						isInvalid={getIn(touched, `event.[${index}].time_trigger._attributes.interval`) &&
																							!!getIn(errors, `event.[${index}].time_trigger._attributes.interval`)} />
																					<Form.Control.Feedback type="invalid">
																						{errorsMap(getIn(errors, `event.[${index}].time_trigger._attributes.interval`))}
																					</Form.Control.Feedback></>
																					:
																					<Form.Control className="form-control" size="sm" type="number" disabled />
																				}
																			</InputGroup>
																		</>
																		: null}
																	{values?.["event"]?.[index]?._attributes?.trigger === "state" && values?.["event"]?.[index]?.state_trigger ?
																		<>
																			<Form.Label>Repeat interval</Form.Label>
																			<InputGroup>
																				<InputGroup.Prepend>
																					<InputGroup.Checkbox
																						checked={values["event"][index].state_trigger._attributes.repeat === "true"}
																						onClick={(e: any) => {
																							let temp_state_trigger = JSON.parse(JSON.stringify(values["event"][index].state_trigger));
																							if (!e.target.checked) {
																								delete temp_state_trigger._attributes.interval;
																								temp_state_trigger._attributes.repeat = "false";
																							} else {
																								temp_state_trigger._attributes.interval = "";
																								temp_state_trigger._attributes.repeat = "true";
																							}
																							setFieldValue(`event.[${index}].state_trigger`, temp_state_trigger);
																						}} />
																				</InputGroup.Prepend>
																				{/* show trigger interval field or dummy depending on if event is repeatable */}
																				{values["event"][index].state_trigger._attributes.repeat ? <>
																					<Form.Control className="form-control" size="sm"
																						type="number"
																						name={`event.[${index}].state_trigger._attributes.interval`}
																						value={values["event"][index].state_trigger._attributes.interval}
																						disabled={values["event"][index].state_trigger._attributes.repeat !== "true"}
																						onChange={handleChange}
																						onBlur={handleBlur}
																						isValid={getIn(touched, `event.[${index}].state_trigger._attributes.interval`) &&
																							!getIn(errors, `event.[${index}].state_trigger._attributes.interval`)}
																						isInvalid={getIn(touched, `event.[${index}].state_trigger._attributes.interval`) &&
																							!!getIn(errors, `event.[${index}].state_trigger._attributes.interval`)} />
																					<Form.Control.Feedback type="invalid">
																						{errorsMap(getIn(errors, `event.[${index}].state_trigger._attributes.interval`))}
																					</Form.Control.Feedback></>
																					:
																					<Form.Control className="form-control" size="sm" type="number" disabled />
																				}
																			</InputGroup>
																		</>
																		: null}
																</Col>
															</Row>
															<br />
															{values?.["event"]?.[index]?._attributes?.trigger === "event" && values?.["event"]?.[index]?.event_trigger ?
																<Row className="justify-content-md-center">
																	{/* Dropdown for choosing an event that triggers this event. cannot choose itself. */}
																	<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																		<Form.Label>Triggering event</Form.Label>
																		<Form.Control as="select" custom
																			id="dropdown-basic-button"
																			size="sm"
																			name={`event.[${index}].event_trigger._attributes.name`}
																			value={values["event"][index].event_trigger._attributes.name}
																			onBlur={handleBlur}
																			onChange={handleChange}
																		>
																			{!values["event"][index].event_trigger._attributes.name ?
																				<option value="">choose event</option>
																				: null}
																			{values.event.filter((event: any) => event._attributes.name !== values["event"][index]._attributes.name)
																				.map((event: any) => {
																					return (
																						<option value={event._attributes.name}>{event._attributes.name}</option>
																					)
																				})}
																		</Form.Control>
																	</Col>
																	<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																		<Form.Label>Trigger delay</Form.Label>
																		<Form.Control className="form-control" size="sm"
																			type="number"
																			name={`event.[${index}].event_trigger._attributes.delay`}
																			value={values["event"][index].event_trigger._attributes.delay}
																			onChange={handleChange}
																			onBlur={handleBlur}
																			isValid={getIn(touched, `event.[${index}].event_trigger._attributes.delay`) &&
																				!getIn(errors, `event.[${index}].event_trigger._attributes.delay`)}
																			isInvalid={getIn(touched, `event.[${index}].event_trigger._attributes.delay`) &&
																				!!getIn(errors, `event.[${index}].event_trigger._attributes.delay`)} />
																		<Form.Control.Feedback type="invalid">
																			{errorsMap(getIn(errors, `event.[${index}].event_trigger._attributes.delay`))}
																		</Form.Control.Feedback>
																	</Col>
																	<br />
																	<br />
																</Row>
																: null}
															{/* Condition, ID, amount for state trigger */}
															{values?.["event"]?.[index]?._attributes?.trigger === "state" && values?.["event"]?.[index]?.state_trigger ?
																<Row className="justify-content-md-center">
																	<Form.Label>Trigger condition</Form.Label>
																	<InputGroup>
																		<InputGroup.Prepend>
																			<Form.Control as="select" custom
																				id="dropdown-basic-button"
																				size="sm"
																				name={`event.[${index}].state_trigger._attributes.condition`}
																				value={values["event"][index].state_trigger._attributes.condition}
																				onBlur={handleBlur}
																				onChange={handleChange}
																			>
																				<option value="greater_than">More than</option>
																				<option value="less_than">Less than</option>
																			</Form.Control>
																		</InputGroup.Prepend>
																		<Form.Control className="form-control" size="sm"
																			type="number"
																			name={`event.[${index}].state_trigger._attributes.amount`}
																			value={values["event"][index].state_trigger._attributes.amount}
																			onChange={handleChange}
																			onBlur={handleBlur}
																			isValid={getIn(touched, `event.[${index}].state_trigger._attributes.amount`) &&
																				!getIn(errors, `event.[${index}].state_trigger._attributes.amount`)}
																			isInvalid={getIn(touched, `event.[${index}].state_trigger._attributes.amount`) &&
																				!!getIn(errors, `event.[${index}].state_trigger._attributes.amount`)} />
																		<Form.Control as="select" custom
																			id="dropdown-basic-button"
																			size="sm"
																			name={`event.[${index}].state_trigger._attributes.id`}
																			value={values["event"][index].state_trigger._attributes.id}
																			onBlur={handleBlur}
																			onChange={handleChange}
																		>
																			{!values["event"][index].state_trigger._attributes.id ?
																				<option value="">molecule</option>
																				: null}
																			{model.speciesList.map((species: any) => {
																				return (
																					<option value={species}>{species}</option>
																				)
																			})}
																		</Form.Control>
																	</InputGroup>
																	<Form.Control.Feedback type="invalid">
																		{errorsMap(getIn(errors, `event.[${index}].state_trigger._attributes.amount`))}
																	</Form.Control.Feedback>
																	<br />
																	<br />
																</Row>
																: null}
															<Row className="justify-content-md-center">
																{values?.["event"]?.[index]?._attributes?.trigger === "time" && values?.["event"]?.[index]?.time_trigger ?
																	<>
																		<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																			<Form.Label>Initial timestep</Form.Label>
																			<Form.Control className="form-control" size="sm"
																				type="number"
																				name={`event.[${index}].time_trigger._attributes.initial`}
																				value={values["event"][index].time_trigger._attributes.initial}
																				onChange={handleChange}
																				onBlur={handleBlur}
																				isValid={getIn(touched, `event.[${index}].time_trigger._attributes.initial`) &&
																					!getIn(errors, `event.[${index}].time_trigger._attributes.initial`)}
																				isInvalid={getIn(touched, `event.[${index}].time_trigger._attributes.initial`) &&
																					!!getIn(errors, `event.[${index}].time_trigger._attributes.initial`)} />
																			<Form.Control.Feedback type="invalid">
																				{errorsMap(getIn(errors, `event.[${index}].time_trigger._attributes.initial`))}
																			</Form.Control.Feedback>
																		</Col>
																		<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																			<Form.Label>Final timestep</Form.Label>
																			<InputGroup>
																				<InputGroup.Prepend>
																					<InputGroup.Checkbox
																						checked={values["event"][index]?.time_trigger?._attributes?.end ||
																							values["event"][index]?.time_trigger?._attributes?.end === "" ||
																							values["event"][index]?.time_trigger?._attributes?.end === 0}
																						onClick={(e: any) => {
																							let temp_time_trigger = JSON.parse(JSON.stringify(values["event"][index].time_trigger));
																							if (!e.target.checked) {
																								delete temp_time_trigger._attributes.end;
																							} else {
																								temp_time_trigger._attributes.end = "";
																							}
																							setFieldValue(`event.[${index}].time_trigger`, temp_time_trigger);
																						}} />
																				</InputGroup.Prepend>
																				{values["event"][index]?.time_trigger?._attributes?.end ||
																					values["event"][index]?.time_trigger?._attributes?.end === "" ||
																					values["event"][index]?.time_trigger?._attributes?.end === 0 ?
																					<><Form.Control className="form-control" size="sm"
																						type="number"
																						name={`event.[${index}].time_trigger._attributes.end`}
																						value={values["event"][index].time_trigger._attributes.end}
																						onChange={handleChange}
																						onBlur={handleBlur}
																						isValid={getIn(touched, `event.[${index}].time_trigger._attributes.end`) &&
																							!getIn(errors, `event.[${index}].time_trigger._attributes.end`)}
																						isInvalid={(getIn(touched, `event.[${index}].time_trigger._attributes.end`) &&
																							(!!getIn(errors, `event.[${index}].time_trigger._attributes.end`)) ||
																							values["event"][index].time_trigger._attributes.end === "")} />
																						<Form.Control.Feedback type="invalid">
																							{errorsMap(getIn(errors, `event.[${index}].time_trigger._attributes.end`))}
																							{getIn(touched, `event.[${index}].time_trigger._attributes.end`) &&
																								values["event"][index].time_trigger._attributes.end === "" ?
																								"If enabled, this field must be filled."
																								: null}
																						</Form.Control.Feedback></>
																					:
																					<Form.Control className="form-control" size="sm" disabled />
																				}
																			</InputGroup>
																		</Col>
																	</>
																	: null}
																{values?.["event"]?.[index]?._attributes?.trigger === "state" && values?.["event"]?.[index]?.state_trigger ?
																	<>
																		<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																			<Form.Label>Initial timestep</Form.Label>
																			<Form.Control className="form-control" size="sm"
																				type="number"
																				name={`event.[${index}].state_trigger._attributes.initial`}
																				value={values["event"][index].state_trigger._attributes.initial}
																				onChange={handleChange}
																				onBlur={handleBlur}
																				isValid={getIn(touched, `event.[${index}].state_trigger._attributes.initial`) &&
																					!getIn(errors, `event.[${index}].state_trigger._attributes.initial`)}
																				isInvalid={getIn(touched, `event.[${index}].state_trigger._attributes.initial`) &&
																					!!getIn(errors, `event.[${index}].state_trigger._attributes.initial`)} />
																			<Form.Control.Feedback type="invalid">
																				{errorsMap(getIn(errors, `event.[${index}].state_trigger._attributes.initial`))}
																			</Form.Control.Feedback>
																		</Col>
																		<Col style={{ paddingLeft: 10, paddingRight: 10 }}>
																			<Form.Label>Final timestep</Form.Label>
																			<InputGroup>
																				<InputGroup.Prepend>
																					<InputGroup.Checkbox
																						checked={values["event"][index]?.state_trigger?._attributes?.end ||
																							values["event"][index]?.state_trigger?._attributes?.end === "" ||
																							values["event"][index]?.state_trigger?._attributes?.end === 0}
																						onClick={(e: any) => {
																							let temp_state_trigger = JSON.parse(JSON.stringify(values["event"][index].state_trigger));
																							if (!e.target.checked) {
																								delete temp_state_trigger._attributes.end;
																							} else {
																								temp_state_trigger._attributes.end = "";
																							}
																							setFieldValue(`event.[${index}].state_trigger`, temp_state_trigger);
																						}} />
																				</InputGroup.Prepend>
																				{values["event"][index]?.state_trigger?._attributes?.end ||
																					values["event"][index]?.state_trigger?._attributes?.end === "" ||
																					values["event"][index]?.state_trigger?._attributes?.end === 0 ?
																					<><Form.Control className="form-control" size="sm"
																						type="number"
																						name={`event.[${index}].state_trigger._attributes.end`}
																						value={values["event"][index].state_trigger._attributes.end}
																						onChange={handleChange}
																						onBlur={handleBlur}
																						isValid={getIn(touched, `event.[${index}].state_trigger._attributes.end`) &&
																							!getIn(errors, `event.[${index}].state_trigger._attributes.end`)}
																						isInvalid={getIn(touched, `event.[${index}].state_trigger._attributes.end`) &&
																							(!!getIn(errors, `event.[${index}].state_trigger._attributes.end`) ||
																								values["event"][index].state_trigger._attributes.end === "")} />
																						<Form.Control.Feedback type="invalid">
																							{errorsMap(getIn(errors, `event.[${index}].state_trigger._attributes.end`))}
																							{getIn(touched, `event.[${index}].state_trigger._attributes.end`) &&
																								values["event"][index].state_trigger._attributes.end === "" ?
																								"If enabled, this field must be filled."
																								: null}
																						</Form.Control.Feedback></>
																					:
																					<Form.Control className="form-control" size="sm" disabled />
																				}
																			</InputGroup>
																		</Col>
																	</>
																	: null}
															</Row>
															{values?.["event"]?.[index]?._attributes?.trigger === "state" ?
																<>
																	<Row className="justify-content-md-center">
																		{/* Provides a dropdown for 3 different formats of location definitions: compart name dropdown, xyz points, xyz range of points */}
																		<Col xs="8">
																			<Form.Label>Trigger location</Form.Label>
																			<Form.Control as="select" custom
																				id="dropdown-basic-button"
																				size="sm"
																				onBlur={handleBlur}
																				defaultValue={getSelectedLocationType(values["event"]?.[index]?.state_trigger_loc?._attributes)}
																				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																					// add the relevant event type node when it is selected from drop down, remove all others
																					handleChange(e);
																					let current_location_value = JSON.parse(JSON.stringify(values["event"][index]));;
																					// deep copy the current values rather than reassign object reference then modifying
																					if (e.target.value === "compart") {
																						setFieldValue(`event.[${index}].state_trigger_loc`, empty_loc_compart)
																					} else if (e.target.value === "point") {
																						setFieldValue(`event.[${index}].state_trigger_loc`, empty_loc_point)
																					} else if (e.target.value === "shape") {
																						setFieldValue(`event.[${index}].state_trigger_loc`, empty_loc_shape)
																					}
																				}}
																			>
																				{!values["event"]?.[index]?.location ?
																					<option value="">choose option</option>
																					: null}
																				<option value="compart">Compartment</option>
																				<option value="point">C-voxel point</option>
																				<option value="shape">C-voxel range</option>
																			</Form.Control>
																		</Col>
																	</Row>
																	{/* Depending on which item was selected above, render the appropriate forms */}
																	{/* This one is compartment list dropdown */}
																	{values["event"]?.[index]?.state_trigger_loc && Object.keys(values["event"]?.[index]?.state_trigger_loc?._attributes).length === 1 ?
																		<Row className="justify-content-md-center">
																			<Col xs="8">
																				<InputGroup size="sm">
																					<InputGroup.Prepend>
																						<InputGroup.Text>Name</InputGroup.Text>
																					</InputGroup.Prepend>
																					<CustomSelect
																						name={`event.[${index}].state_trigger_loc._attributes.compartment`}
																						value={values["event"][index].state_trigger_loc._attributes.compartment}
																						defaultOptionString="compartment"
																						touched={touched}
																						errors={errors}
																						optionsArray={model.compartList}
																						onChange={handleChange}
																						onBlur={handleBlur} />
																				</InputGroup>
																				<Row className="justify-content-center custom-error">
																					{errorsMap(getIn(errors, `event.[${index}].state_trigger_loc._attributes.compartment`))}
																				</Row>
																			</Col>
																		</Row>
																		: null}
																	{/* This one is xyz coord for 1 point. It's only identifier is the number of its attributes, not a label*/}
																	{values["event"]?.[index]?.state_trigger_loc && Object.keys(values["event"]?.[index]?.state_trigger_loc?._attributes).length === 3 ?
																		<EventCompart3
																			name={`event.[${index}].state_trigger_loc._attributes`}
																			value={values["event"][index].state_trigger_loc._attributes}
																			touched={touched}
																			errors={errors}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		: null}
																	{/* This one is a range of points from 6 coordinates in xyz */}
																	{values["event"]?.[index]?.state_trigger_loc && Object.keys(values["event"]?.[index]?.state_trigger_loc?._attributes).length === 6 ?
																		<EventCompart6
																			name={`event.[${index}].state_trigger_loc._attributes`}
																			value={values["event"][index].state_trigger_loc._attributes}
																			touched={touched}
																			errors={errors}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		: null}
																</>
																: null}
														</Card.Body></Card>

													</Col>
												</Row>

												{/* Second row has Event location card */}

												<br />
											</Card>
											<Button type="button" variant="outline-danger" onClick={() => {
												arrayHelpers.remove(index)
											}}>Remove event</Button>
											<br />
											<br />
										</div>
									)) : null
								}
									{/* button for adding more event cards */}
									<Button type="button" onClick={() => arrayHelpers.push(emptyEvent)}>Add new event</Button>
								</div>
								)
							}}
							/>
							<hr />
							{/* <Row className="text-left">
								<Col>
									<p>Values</p>
									<pre>{JSON.stringify(values?.["event"], null, 2)}</pre>
								</Col>
								<Col>
									<p>Errors</p>
									<pre>{JSON.stringify(errors?.["event"], null, 2)}</pre>
								</Col>
								<Col>
									<p>Touched</p>
									<pre>{JSON.stringify(touched?.["event"], null, 2)}</pre>
								</Col>
							</Row> */}
							<Button type="submit" onClick={() => setSubmitSuccess(false)}>Save Events to model</Button>
							{submitSuccess ? <><br /><br /><div className="alert-success col-lg justify-content-md-center">Events saved to model!</div></> : 
											 touchedSubmit ? <><br /><br /><div className="alert-danger col-lg justify-content-md-center">Events failed to save.</div></> :
											 null}
						</Container>
					</Form>
				)}
			</Formik>
		</div >
	);
}
